import cn from "classnames";
import { FC, ReactNode } from "react";
import { setTheme } from "@/helpers";

export type FeaturesOverviewProps = {
  className?: string;
  theme?: "white" | "gray" | "black";
  children?: ReactNode;
};

const FeaturesOverview: FC<FeaturesOverviewProps> = ({
  className,
  theme,
  children,
}) => {
  return (
    <div
      className={cn("bg-background py-12 sm:py-16", className)}
      {...setTheme(theme)}
    >
      {children}
    </div>
  );
};

export default FeaturesOverview;
